import Agriculture from './images/agriculture.svg'
import GenericProgrammesAndQualifications from './images/general-learning.svg';
import Education from './images/education.svg'
import ArtsAndHumanities from './images/art.svg'
import Journalism from './images/journalism.svg'
import Business from './images/business.svg'
import Science from './images/science.svg'
import InformationAndCommunicationTechnologies from './images/it.svg'
import Engineering from './images/engineering.svg'
import Health from './images/health.svg'
import Services from './images/services.svg'
import Online from './images/categories/Online.png'
import FullTimeSVG from './images/full-time.svg';
import PartTimeSVG from './images/part-time.svg';

export const CourseCardIcon = ({title}) => {
    return (
      <img src={
        {
          'Fulltime': FullTimeSVG,
          'Parttime': PartTimeSVG,
          'Online': Online,
          'Generic programmes and qualifications': GenericProgrammesAndQualifications,
          'Education': Education,
          'Arts and humanities': ArtsAndHumanities,
          'Social sciences, journalism and information': Journalism,
          'Business and administration and law': Business,
          'Natural sciences,mathematics and statistics': Science,
          'Information and Communication Technologies (ICTs)': InformationAndCommunicationTechnologies,
          'Engineering, manufacturing and construction': Engineering,
          'Agriculture, forestry, fisheries and veterinary': Agriculture,
          'Health and welfare': Health,
          'Services': Services,  
        }[title] || Services
      } alt={title} height={'32px'} width={'32px'}/>
    )
  }